import React, { Component } from "react";
import { StyleSheet, css } from "aphrodite";
import GoogleMapReact from "google-map-react";
import Popup from "reactjs-popup";
import { withRouter } from "react-router-dom";

import "reactjs-popup/dist/index.css";
import "./UniMap.css";
import Header from "../Components/Header";
import Consts from "../Constants/AppConsts.json";
import Data from "../Constants/Locations.json";
import ImgConsts from "../Constants/ImgConsts";
import Colors from "../Theme/Colors";
import { isObjectEmpty } from "../Utils";
import PopUpContents from "../Views/PopUpContents";
import Images from "../Theme/Images";

class UniMap extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentLocation: {},
      isTypeSelectionOn: props.typeSelectorOn ? props.typeSelectorOn : false,
      hideInfo: props.typeSelectorOn ? props.typeSelectorOn : false,
    };
    this.ref = React.createRef();
  }
  handleMarkers = ({ map, maps }) => {
    Data.locations.forEach((point) => {
      let title = point.title;
      let marker = new maps.Marker({
        animation: maps.Animation.DROP,
        title: point.title,
        label: {
          text: title,
          color: Colors.BLUE_COLOR,
        },
        icon: {
          path: ImgConsts.icon,
          fillColor: Colors.BLUE_COLOR,
          fillOpacity: 1,
          strokeColor: Colors.WHITE_COLOR,
          strokeWeight: 1,
          anchor: new maps.Point(14, 43),
          labelOrigin: new maps.Point(13.5, -8),
        },
        position: { lat: point.latitude, lng: point.longitude },
      });
      marker.addListener("click", () => this.onClickAPoint(point));
      marker.setMap(map);
    });
  };

  onClosePopup = () => {
    this.setState({
      currentLocation: {},
      isTypeSelectionOn: false,
      hideInfo: true,
    });
  };

  onClickAPoint = (point) => {
    this.setState({ currentLocation: point, hideInfo: true });
  };

  popupOpener = (interestedPoint, isFromSelection) => {
    if (!isFromSelection) {
      return !isObjectEmpty(interestedPoint);
    }
    if (isFromSelection) {
      return true;
    }
  };

  onRequestClosePopUp = () => {
    this.onClosePopup();
    setTimeout(this.ref.current.close, 0);
  };

  closeInfoWindow = () => {
    this.setState({ hideInfo: true });
  };

  render() {
    const { currentLocation, isTypeSelectionOn, hideInfo } = this.state;
    return (
      <div key={this.props.key} className={css(styles.main)}>
        <div className={css(styles.map)}>
          <GoogleMapReact
            bootstrapURLKeys={{
              key: Consts.Google_Maps_Key,
            }}
            defaultCenter={PageConstants.Default_Center}
            defaultZoom={PageConstants.Default_Zoom}
            options={createMapOptions}
            onGoogleApiLoaded={isTypeSelectionOn ? null : this.handleMarkers}
          ></GoogleMapReact>
        </div>
        <Header
          history={this.props.history}
          currentPath={this.props.currentPath}
          headerText={Consts.Header_Text}
        />
        <Popup
          ref={this.ref}
          open={this.popupOpener(currentLocation, isTypeSelectionOn)}
          onClose={this.onClosePopup}
          position="right center"
          className={isTypeSelectionOn ? "popup-small" : "my-popup"}
          disabled={isTypeSelectionOn ? true : false}
        >
          <PopUpContents
            isContentAvailable={!isTypeSelectionOn}
            currentLocation={currentLocation}
            onRequestClosePopUp={this.onRequestClosePopUp}
            history={this.props.history}
            currentPath={this.props.currentPath}
          />
        </Popup>
        <div className={hideInfo ? "info-box hidden" : "info-box"}>
          <div className="button-div">
            <input
              onClick={this.closeInfoWindow}
              alt=""
              className="close-image"
              type="image"
              src={Images.close}
            />
          </div>
          <span className="info-text">{Consts.how_to_dept}</span>
        </div>
      </div>
    );
  }
}

const PageConstants = {
  USJ_BOUNDS: {
    north: 6.856604,
    south: 6.84993,
    west: 79.900624,
    east: 79.906718,
  },
  Default_Center: {
    lat: 6.853323,
    lng: 79.903944,
  },
  Default_Zoom: 18,
};

function createMapOptions(maps) {
  return {
    disableDoubleClickZoom: true,
    scrollwheel: false,
    restriction: {
      latLngBounds: PageConstants.USJ_BOUNDS,
      strictBounds: false,
    },
    styles: [
      {
        featureType: "poi",
        elementType: "labels",
        stylers: [{ visibility: "off" }],
      },
    ],
  };
}

let styles = StyleSheet.create({
  button: {
    elevation: 100,
    alignSelf: "center",
  },
  container: {
    flex: 1,
    backgroundColor: "red",
  },
  header: {
    position: "absolute",
    top: "0px",
  },
  main: {
    justifyContent: "center",
  },
  map: {
    height: "98vh",
    width: "100%",
  },
});

export default withRouter(UniMap);
